<div class="component-body">
  <main class="main d-flex align-items-center">
    <div class="container">
<br>
<br>
<br>
<br>
<br>

      <div class="row">

      
        <div class="col-lg-6  col-sm-12 col-md-6 mx-auto">

          <div class="card-group">            
            <div class="card p-10">

    

     <mat-horizontal-stepper #stepper linear >
         <mat-step [stepControl]="LoginForm.get('LoginPage')" [completed]="isCompleted">
         

          
          <div style="text-align: center;">
            <h1> <font color="#005b9d">    <img style="max-width:100%; height:auto;"  src="../../../../../assets/images/Premier1.jpg" alt="../../../../../assets/images/premierlogonew.jpg"/> </font></h1>
        </div>

      
                <div style="text-align: center;">
                    <h1> <font color="#005b9d">{{'loginSection.TranslationSection.text1' | translate}}</font></h1>
                </div>
  
                <div class="card-body">
                 
                  <form [formGroup] = "LoginForm.get('LoginPage')" (ngSubmit) = "login(LoginForm.get('LoginPage').value)">
                    <h1>{{'loginSection.TranslationSection.text2' | translate}}</h1>
                    <p>{{'loginSection.TranslationSection.text3' | translate}}<br><label style="font-size: medium; font-weight: bold; ">{{'loginSection.TranslationSection.text4' | translate}} (jsmith@gmail.com)</label></p>

                    <div *ngIf="showErrorMessage">
                      <label style="font-size: small;color:#b30000">{{'loginSection.TranslationSection.text10' | translate}}</label>
                    </div>

        <!--
                      <div class=" input-group mb-4">
                       <label style = "color: green;"><b>Select language to take application</b></label> :&nbsp;<div id="google_translate_element"></div>
                          </div>-->
               
                 
                    <div class="input-group mb-4">
                     
                      <input type="text" class="form-control" formControlName = "username" placeholder="{{'loginSection.TranslationSection.text5' | translate}}" autocomplete="username"   >

                    </div>
                    <div class="input-group mb-4">
                   
                      <input type="password" class="form-control" formControlName = "password" placeholder="{{'loginSection.TranslationSection.text6' | translate}}" autocomplete="current-password"  >
                    </div>
                    <div class="row">
                      <div class="col-sm-12  col-md-12 col-lg-12">
                  

                        <button type="submit" style="background-color:#005b9d; color:white; width:70px;" class="btn btn-md pull-right">{{'loginSection.TranslationSection.text7' | translate}}</button>

                        &nbsp;&nbsp;&nbsp;<a href="{{enrollURL}}/#/signup">{{'loginSection.TranslationSection.text8' | translate}}</a>



                        <button mat-button (click)="goForward(stepper)" type="button">{{'loginSection.TranslationSection.text9' | translate}}</button>
                      </div>

         
                 
                    </div>


                    
                  </form>
                </div>


                <div id="loadimage" style="text-align: center;">
                  <img *ngIf="loading" style = "width:40px; height:40px;" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              </div>

          </mat-step>
  


          <mat-step  [stepControl]="LoginForm.get('ThankYouPage')">

        

          <div class="card-body">
            <app-reset-email [loginForm]="LoginForm.get('ThankYouPage')" ></app-reset-email>
          </div>
        

          </mat-step>
        

        </mat-horizontal-stepper>


      </div>    
    </div>



        </div>
      </div>
    </div>
  </main>
</div>


